export const SELFIE_CHECK_FILTER_ENABLED = 'SELFIE_CHECK_FILTER_ENABLED'
export const SELFIE_CHECK_FILTER_DISABLED = 'SELFIE_CHECK_FILTER_DISABLED'

function enable(selfieCheckFilter) {
  return {
    type: SELFIE_CHECK_FILTER_ENABLED,
    selfieCheckFilter,
  }
}

function disable() {
  return {
    type: SELFIE_CHECK_FILTER_DISABLED,
    selfieCheckFilter: null,
  }
}

export function enableSelfieCheckFilter(filter) {
  return (dispatch) => {
    dispatch(enable(filter))
  }
}

export function disableSelfieCheckFilter() {
  return (dispatch) => {
    dispatch(disable())
  }
}
